export default __webpack_public_path__ + "static/media/Edit.0f7d6880.svg";